import React, { useContext, useEffect, useRef } from 'react'
import { dataContext, localestr, itemToText, toText, uid, load, beginMn, endMn } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import Menu from '../cmp/menu.js'
import UniTable from '../cmp/UniTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import icon from '../icons.svg'
import SalaryForm from '../cmp/SalaryForm.js' //+

let loading = false

let findDlg = false

const pr_min = 3028  //Прожитковий мінімум

function DocSalaryEdit({ data, actions }) {
  const targetRef = useRef()
  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabNew = actions.tabNew
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  const msg = context.msg
  const loaddata = context.loaddata
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings().docSalaryEdit
  const inputCols = context.inputCols

  const catEmployees = context.data['catEmployees']
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id===(wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if((context.user || {}).rights?.urDocs3Edit){
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocs7Edit){
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocsREdit){
    if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if(urAdmin){
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if(posted){
    if(wndData.date && wndData.date > minDate){
      if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  //const [edit, setEdit] = useState(false)
  const edit = (getGlData() || {}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  //const [isActive2, setisActive] = useState(false)

  const cols = [
    { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    { caption: localestr('Працівник'), minWidth: '70', dataId: 'employee', sortable: true, typeVal: 'catEmployees', setFn: (d) => { setVal('employee', d) } },
    { caption: localestr('Днів'), minWidth: '20', maxWidth: '40', dataId: 'days', sortable: true, typeVal: 'number', setFn: (d) => { setVal('days', d) } },
    { caption: localestr('Годин'), minWidth: '25', maxWidth: '50', dataId: 'hours', sortable: true, typeVal: 'number', setFn: (d) => { setVal('hours', d) } },
    { caption: localestr('Оклад'), minWidth: '40', maxWidth: '75', dataId: 'sum_m', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_m', d) } },
    { caption: localestr('Поденно'), minWidth: '40', maxWidth: '75', dataId: 'sum_d', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_d', d) } },
    { caption: localestr('Погодинно'), minWidth: '40', maxWidth: '75', dataId: 'sum_h', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_h', d) } },
    { caption: localestr('По виручці'), minWidth: '40', maxWidth: '75', dataId: 'sum_a', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_a', d) } },
    { caption: localestr('По підрозділу 1'), minWidth: '40', maxWidth: '75', dataId: 'sum_d1', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_d1', d) } },
    { caption: localestr('По підрозділу 2'), minWidth: '40', maxWidth: '75', dataId: 'sum_d2', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_d2', d) } },
    { caption: localestr('По загальній виручці'), minWidth: '40', maxWidth: '75', dataId: 'sum_t', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_t', d) } },
    { caption: localestr('Премія'), minWidth: '40', maxWidth: '75', dataId: 'bonus', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('bonus', d) } },
    { caption: localestr('Лікарняні'), minWidth: '40', maxWidth: '75', dataId: 'sick', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sick', d) } },
    { caption: localestr('Відпускні'), minWidth: '40', maxWidth: '75', dataId: 'vacation', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('vacation', d) } },
    { caption: localestr('Разом нараховано'), minWidth: '55', maxWidth: '95', dataId: 'totall', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('totall', d) } },
    { caption: localestr('База для податків'), minWidth: '40', maxWidth: '75', dataId: 'tax_base', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('tax_base', d) } },
    { caption: localestr('ПДФО'), minWidth: '40', maxWidth: '75', dataId: 'inc_tax', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('inc_tax', d) } },
    { caption: localestr('Військовий збір'), minWidth: '40', maxWidth: '75', dataId: 'mil_tax', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('mil_tax', d) } },
    { caption: localestr('ЄСВ'), minWidth: '40', maxWidth: '75', dataId: 'esv', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('esv', d) } },
    { caption: localestr('До виплати'), minWidth: '55', maxWidth: '95', dataId: 'amount', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('amount', d) } },

  ]

  if (usersettings && usersettings.cols) {
    for (let i = 0; i < usersettings.cols.length; i++) {
      const idx = cols.findIndex(el => el.dataId === usersettings.cols[i])
      if (idx !== -1) cols[idx].hiden = true
    }
  } else {
    cols[4].hiden = true
    cols[5].hiden = true
    cols[6].hiden = true
    cols[7].hiden = true
    cols[8].hiden = true
    cols[9].hiden = true
    cols[10].hiden = true
    cols[11].hiden = true
    cols[12].hiden = true
    cols[13].hiden = true
    cols[15].hiden = true
    cols[16].hiden = true
    cols[17].hiden = true
    cols[18].hiden = true
  }

  const filterData = [ //+
    { caption: localestr('Працівник'), dataId: 'employee', typeVal: 'catEmployees' },
    { caption: localestr('Днів'), dataId: 'days', typeVal: 'number' },
    { caption: localestr('Годин'), dataId: 'hours', typeVal: 'number' },
    { caption: localestr('Оклад'), dataId: 'sum_m', typeVal: 'number' },
    { caption: localestr('Поденно'), dataId: 'sum_d', typeVal: 'number' },
    { caption: localestr('Погодинно'), dataId: 'sum_h', typeVal: 'number' },
    { caption: localestr('По виручці'), dataId: 'sum_a', typeVal: 'number' },
    { caption: localestr('По підрозділу 1'), dataId: 'sum_d1', typeVal: 'number' },
    { caption: localestr('По підрозділу 2'), dataId: 'sum_d2', typeVal: 'number' },
    { caption: localestr('По загальній виручці'), dataId: 'sum_t', typeVal: 'number' },
    { caption: localestr('Премія'), dataId: 'bonus', typeVal: 'number' },
    { caption: localestr('Лікарняні'), dataId: 'sick', typeVal: 'number' },
    { caption: localestr('Відпускні'), dataId: 'vacation', typeVal: 'number' },
    { caption: localestr('Разом нараховано'), dataId: 'totall', typeVal: 'number' },
    { caption: localestr('База для податків'), dataId: 'tax_base', typeVal: 'number' },
    { caption: localestr('ПДФО'), dataId: 'inc_tax', typeVal: 'number' },
    { caption: localestr('Військовий збір'), dataId: 'mil_tax', typeVal: 'number' },
    { caption: localestr('ЄСВ'), dataId: 'esv', typeVal: 'number' },
    { caption: localestr('До виплати'), dataId: 'amount', typeVal: 'number' },
  ]

  const setFilter = (id, val, type) => {
    let filter = [...(wndData.filter || [])]
    const idx = filter.findIndex(el => el.dataId === id)
    if (idx !== -1) {
      if (!val) filter.splice(idx, 1)
      else filter[idx].value = val
    } else if (val) filter.push({ dataId: id, compare: 'lk', value: val, typeVal: type })
    if (!filter.length) filter = undefined
    setWndData({ ...wndData, filter, currentCol: undefined })
    setGlData({ needFocus: 1 })
    tblPos(0)
  }

  const showHideFilter = () => {
    const showAFilter = !wndData.showAFilter
    if (!showAFilter) setWndData({ ...wndData, filter: undefined, showAFilter })
    else setWndData({ ...wndData, showAFilter })
  }

  const listFromData = (currentCol, setCurrCol) => {
    let list = []
    if (wndData.table) list = wndData.table.map((item) => {
      const newItem = { uid: uid(), ...item, employee: { id: item.employee_id, name: item.employee } }
      //if(item.edit) newItem.edit=true
      if (typeof currentCol !== 'undefined' && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const setHidenCols = (data) => {
    if (data) {
      const new_data = data.filter(el => el.hiden).map(el => el.dataId)
      setSettings({ docSalaryEdit: { cols: new_data } })
    } else {
      if (edit) return
      inputCols(cols, setHidenCols)
    }
  }

  const setCol = (currentCol) => {
    //if(!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    setWndData({ ...wndData, currentCol, oldCol })

    setGlData({ needFocus: 0 })
  }

  const getData = (d, act) => {
    if (d) {
      const status = d.status
      let loaded = 1
      if (wndData.loaded) {
        loaded += wndData.loaded
      }
      if (loaded > 10) loaded = 0
      if (loaded > 1) return
      if (status === 'OffLine') msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      else if (status === 'error') msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      setWndData({ ...wndData, salaryData: d.data, loaded })
      setTimeout(() => { wndData = actions.getWndData(); act() }, 200)
    } else {
      let from = beginMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      let to = endMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      if (wndData.from_d) from = wndData.from_d.substring(0, 10) + 'T00:00:00Z'
      if (wndData.to_d) to = wndData.to_d.substring(0, 10) + 'T23:59:59Z'
      load('action=getSalaryData&data=' + JSON.stringify({ from, to }), (dt) => { getData(dt, act) })
    }
  }

  const fillEmployee = (emp) => {
    const currentCol = { employee: emp }
    const empl = catEmployees.find(el => el.id === emp.id)
    if (empl) {
      currentCol.employee = empl
      currentCol.expenses = empl.expenses || ''
      currentCol.days = ''
      currentCol.hours = ''
      currentCol.amount_a = ''
      currentCol.amount_d1 = ''
      currentCol.amount_d2 = ''
      currentCol.amount_t = ''
      currentCol.sum_m = empl.sum_m || ''
      currentCol.sum_d = ''
      currentCol.sum_h = ''
      currentCol.sum_a = ''
      currentCol.sum_d1 = ''
      currentCol.sum_d2 = ''
      currentCol.sum_t = ''
      currentCol.bonus = ''
      currentCol.sick = ''
      currentCol.vacation = ''
      currentCol.totall = ''
      currentCol.tax_base = ''
      currentCol.inc_tax = ''
      currentCol.mil_tax = ''
      currentCol.esv = ''
      currentCol.totall = ''
      if (wndData.salaryData) {
        const dates = wndData.salaryData.dates
        let idx = wndData.salaryData.time.findIndex(el => el.employee_id === currentCol.employee.id)
        if (idx !== -1) {
          currentCol.days = wndData.salaryData.time[idx].days
          currentCol.hours = Math.round(wndData.salaryData.time[idx].mins / 60)
        }
        if (currentCol.employee.author && currentCol.employee.author.id) {
          const amount_a = wndData.salaryData.sales.reduce((a, c) => { return a + (c.author_id === currentCol.employee.author.id ? c.amount : 0) }, 0)
          currentCol.amount_a = amount_a.toFixed(2)
        }
        if (currentCol.employee.department1 && currentCol.employee.department1.id) {
          const amount_a = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) !== -1 && c.department_id === currentCol.employee.department1.id ? c.amount : 0) }, 0)
          currentCol.amount_d1 = amount_a.toFixed(2)
        }
        if (currentCol.employee.department2 && currentCol.employee.department2.id) {
          const amount_a = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) !== -1 && c.department_id === currentCol.employee.department2.id ? c.amount : 0) }, 0)
          currentCol.amount_d2 = amount_a.toFixed(2)
        }
        const amount_t = wndData.salaryData.sales.reduce((a, c) => { return a + (dates.findIndex(it => it === currentCol.employee.id + '&&' + c.date) === -1 ? 0 : c.amount) }, 0)
        //const amount_t=wndData.salaryData.sales.reduce((a, c) =>{console.log(c);return a + c.amount},0)
        if (amount_t) currentCol.amount_t = amount_t.toFixed(2)

      }
      if (currentCol.employee.sum_d) {
        const sum_d = parseFloat(currentCol.employee.sum_d || 0) * parseFloat(currentCol.days || 0)
        currentCol.sum_d = sum_d.toFixed(2)
      }
      if (currentCol.employee.sum_h) {
        const sum_h = parseFloat(currentCol.employee.sum_h || 0) * parseFloat(currentCol.hours || 0)
        currentCol.sum_h = sum_h.toFixed(2)
      }
      if (currentCol.employee.prc_a) {
        const sum_a = parseFloat(currentCol.employee.prc_a || 0) * parseFloat(currentCol.amount_a || 0) / 100
        currentCol.sum_a = sum_a.toFixed(2)
      }
      if (currentCol.employee.prc_d1) {
        const sum_d1 = parseFloat(currentCol.employee.prc_d1 || 0) * parseFloat(currentCol.amount_d1 || 0) / 100
        currentCol.sum_d1 = sum_d1.toFixed(2)
      }
      if (currentCol.employee.prc_d2) {
        const sum_d2 = parseFloat(currentCol.employee.prc_d2 || 0) * parseFloat(currentCol.amount_d2 || 0) / 100
        currentCol.sum_d2 = sum_d2.toFixed(2)
      }
      if (currentCol.employee.prc_t) {
        const sum_t = parseFloat(currentCol.employee.prc_t || 0) * parseFloat(currentCol.amount_t || 0) / 100
        currentCol.sum_t = sum_t.toFixed(2)
      }
      const totall = parseFloat(currentCol.sum_m || 0) + parseFloat(currentCol.sum_d || 0) + parseFloat(currentCol.sum_h || 0) + parseFloat(currentCol.sum_a || 0) +
        parseFloat(currentCol.sum_d1 || 0) + parseFloat(currentCol.sum_d2 || 0) + parseFloat(currentCol.sum_t || 0) + parseFloat(currentCol.bonus || 0) +
        parseFloat(currentCol.sick || 0) + parseFloat(currentCol.vacation || 0)
      currentCol.totall = totall.toFixed(2)
      if (parseInt(currentCol.employee.taxes || 0)) {
        let tax_base = parseFloat(currentCol.totall || 0)
        if (parseFloat(currentCol.employee.tax_base || 0) !== 0) tax_base = parseFloat(currentCol.employee.tax_base || 0)
        currentCol.tax_base = tax_base.toFixed(2)
        const mil_tax = parseFloat(currentCol.tax_base || 0) * 0.05
        currentCol.mil_tax = mil_tax.toFixed(2)
        //ПДФО Податкова соціальна пільга дорівнює 50% розміру прожиткового мінімуму на 1 січня звітного року.
        //Межа розмір прожиткового мінімуму на 1 січня звітного року, помноженого на 1,4 та округленого до найближчих 10 гривень.
        const pr_limit = Math.round(pr_min * 0.14) * 10
        let base = parseFloat(currentCol.tax_base || 0)
        if (base <= pr_limit) base -= pr_min * 0.5
        if (base < 0) base = 0
        const inc_tax = base * 0.18
        currentCol.inc_tax = inc_tax.toFixed(2)
        const esv = parseFloat(currentCol.tax_base || 0) * 0.22
        currentCol.esv = esv.toFixed(2)
      }
      let taxes = parseFloat(currentCol.inc_tax || 0) + parseFloat(currentCol.mil_tax || 0) + parseFloat(currentCol.esv || 0)
      currentCol.taxes = taxes.toFixed(2)
      let amount = parseFloat(currentCol.totall || 0)
      if (parseInt(currentCol.employee.taxes || 0) && !parseInt(currentCol.expenses || 0)) amount -= (parseFloat(currentCol.inc_tax || 0) + parseFloat(currentCol.mil_tax || 0))
      currentCol.amount = amount.toFixed(2)
    }
    return currentCol
  }

  const setVal = (name, data) => {
    if (!wndData.salaryData) { getData(null, () => setVal(name, data)); return }
    let currentCol = { ...wndData.currentCol }
    currentCol[name] = data
    if (name !== 'employee') {
      if (typeof currentCol.employee.sum_d === 'undefined') {
        const empl = catEmployees.find(el => el.id === currentCol.employee.id)
        if (empl) {
          currentCol.employee = empl
        }
      }
    } else {
      currentCol.expenses = currentCol.employee.expenses
      //Перерахувати все
      currentCol = { ...wndData.currentCol, ...fillEmployee(data) }
    }
    if (name === 'days') {
      if (currentCol.employee.sum_d) {
        const sum_d = parseFloat(currentCol.employee.sum_d || 0) * parseFloat(data || 0)
        currentCol.sum_d = sum_d.toFixed(2)
        name = 'sum_d'
      }
    }
    if (name === 'hours') {
      if (currentCol.employee.sum_h) {
        const sum_h = parseFloat(currentCol.employee.sum_h || 0) * parseFloat(data || 0)
        currentCol.sum_h = sum_h.toFixed(2)
        name = 'sum_h'
      }
    }
    if (name === 'amount_a') {
      if (currentCol.employee.prc_a) {
        const sum_a = parseFloat(currentCol.employee.prc_a || 0) * parseFloat(data || 0) / 100
        currentCol.sum_a = sum_a.toFixed(2)
        name = 'sum_a'
      }
    }
    if (name === 'amount_d1') {
      if (currentCol.employee.prc_d1) {
        const sum_d1 = parseFloat(currentCol.employee.prc_d1 || 0) * parseFloat(data || 0) / 100
        currentCol.sum_d1 = sum_d1.toFixed(2)
        name = 'sum_d1'
      }
    }
    if (name === 'amount_d2') {
      if (currentCol.employee.prc_d2) {
        const sum_d2 = parseFloat(currentCol.employee.prc_d2 || 0) * parseFloat(data || 0) / 100
        currentCol.sum_d2 = sum_d2.toFixed(2)
        name = 'sum_d2'
      }
    }
    if (name === 'amount_t') {
      if (currentCol.employee.prc_t) {
        const sum_t = parseFloat(currentCol.employee.prc_t || 0) * parseFloat(data || 0) / 100
        currentCol.sum_t = sum_t.toFixed(2)
        name = 'sum_t'
      }
    }
    if (name === 'sum_m' || name === 'sum_d' || name === 'sum_h' || name === 'sum_a' || name === 'sum_d1' || name === 'sum_d2' || name === 'sum_t' || name === 'bonus' || name === 'sick' || name === 'vacation') {
      const totall = parseFloat(currentCol.sum_m || 0) + parseFloat(currentCol.sum_d || 0) + parseFloat(currentCol.sum_h || 0) + parseFloat(currentCol.sum_a || 0) +
        parseFloat(currentCol.sum_d1 || 0) + parseFloat(currentCol.sum_d2 || 0) + parseFloat(currentCol.sum_t || 0) + parseFloat(currentCol.bonus || 0) +
        parseFloat(currentCol.sick || 0) + parseFloat(currentCol.vacation || 0)
      currentCol.totall = totall.toFixed(2)
      name = 'totall'
    }
    if (name === 'totall') {
      if (parseInt(currentCol.employee.taxes || 0) && parseFloat(currentCol.employee.tax_base || 0) === 0) {
        const tax_base = parseFloat(currentCol.totall || 0)
        currentCol.tax_base = tax_base.toFixed(2)
        name = 'tax_base'
      }
    }
    if (name === 'tax_base') {
      if (parseInt(currentCol.employee.taxes || 0)) {
        const mil_tax = parseFloat(currentCol.tax_base || 0) * 0.05
        currentCol.mil_tax = mil_tax.toFixed(2)
        //ПДФО Податкова соціальна пільга дорівнює 50% розміру прожиткового мінімуму на 1 січня звітного року.
        //Межа розмір прожиткового мінімуму на 1 січня звітного року, помноженого на 1,4 та округленого до найближчих 10 гривень.
        const pr_limit = Math.round(pr_min * 0.14) * 10
        let base = parseFloat(currentCol.tax_base || 0)
        if (base <= pr_limit) base -= pr_min * 0.5
        if (base < 0) base = 0
        const inc_tax = base * 0.18
        currentCol.inc_tax = inc_tax.toFixed(2)
        const esv = parseFloat(currentCol.tax_base || 0) * 0.22
        currentCol.esv = esv.toFixed(2)
        name = 'mil_tax'
      }
    }
    if (name === 'totall' || name === 'inc_tax' || name === 'mil_tax' || name === 'esv' || name === 'expenses') {
      let taxes = parseFloat(currentCol.inc_tax || 0) + parseFloat(currentCol.mil_tax || 0) + parseFloat(currentCol.esv || 0)
      currentCol.taxes = taxes.toFixed(2)
      let amount = parseFloat(currentCol.totall || 0)
      if (!parseInt(currentCol.expenses || 0)) amount -= (parseFloat(currentCol.inc_tax || 0) + parseFloat(currentCol.mil_tax || 0))
      currentCol.amount = amount.toFixed(2)
    }
    setWndData({ ...wndData, currentCol })
    setEdit(true)
  }

  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    //setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    //setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (!newData.edit) newData.edit = true
    if (name === 'from_d' || name === 'to_d') { newData.loaded = 0; newData.salaryData = null }
    setWndData(newData, true)
  }

  const saveValue = (act = null) => {
    let errmsg = ''
    const currCol = { ...wndData.currentCol, edited: true }
    const list = wndData.list
    if (!currCol) return
    //currCol.refuse=typeof currCol.refuse==='object'?currCol.refuse:selYN.find(x => x.value === (currCol.refuse||'0'))
    //currCol.status=typeof currCol.status==='object'?currCol.status:selOrderStatus.find(x => x.value === (currCol.status||'0'))
    //if (!currCol.menu && !currCol.hide) errmsg=localestr("Не заповнено меню")
    //if (!currCol.sum_qtt&&!currCol.sum_bruto) errmsg=localestr("Не заповнено кількість або суму")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      //currCol.sum_qtt=parseFloat(currCol.sum_qtt).toFixed(3)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      setWndData(newData, true)
      setEdit(false)
      //setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
    }
  }

  const newItem = () => {
    if (posted) return
    //if ((getGlData()||{}).edit) {saveValue(()=>{newItem()});return}
    if (edit) return
    //setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const copyItem = () => {
    if (posted) return
    //if ((getGlData()||{}).edit) {saveValue(()=>{copyItem()});return}
    if (edit) return
    if (typeof wndData.currentCol === 'object') {
      //setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    if (posted) return
    if (!wndData.salaryData) { getData(null, editItem); return }
    if (!wndData.currentCol) return
    //setisActive(true)
    const currentCol = { ...wndData.currentCol }
    const oldCol = { ...wndData.currentCol }
    setWndData({ ...wndData, currentCol, oldCol })
    setEdit(true)
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const selectionProc = (e) => {
    if (posted) return
    //if ((getGlData()||{}).edit) {saveValue(()=>{selectionProc(e)});return}
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    let newData = { ...wndData, findText: '', findArr: null }
    let list = newData.list
    let el = list.find(m => m.employee.id === e.id)
    if (!el) {
      el = { ...fillEmployee(e), uid: uid(), edited: true }
      list.push(el)
    } else if (el.hide) {
      el.hide = false
      el.edited = true
    } else {
      el.edited = true
    }
    newData.currentCol = { ...el }
    newData.list = list
    if (newData.currFind !== undefined) {
      newData.currFind = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('search')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = () => {
    if (posted) return
    if (edit) return
    //if ((getGlData()||{}).edit) {saveValue(()=>{removeItem()});return}
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edited: true, hide: true }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const fillDoc = (clr = 1) => {
    if (posted) return
    if (!wndData.salaryData) { getData(null, fillDoc); return }
    if (wndData.list && wndData.list.length && clr) {
      msg(localestr('Документ буде очищено перед заповненням. Продовжити?'), localestr('Запитання'), [{ caption: localestr('Так'), action: () => fillDoc(0) }, { caption: localestr('Відмінити'), action: () => { } }])
      return
    }
    const list = []
    if (catEmployees) {
      let from = beginMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      let to = endMn(wndData.date).toISOString().substring(0, 19) + 'Z'
      for (let i = 0; i < catEmployees.length; i++) {
        const item = catEmployees[i]
        if (item.start > to) continue
        if (item.finish && item.finish < from) continue
        list.push({ ...fillEmployee(item), uid: uid(), edited: true })
      }
      setWndData({ ...wndData, list }, true)
    }
  }

  const saveDoc = (d, close = true) => {
    //if ((getGlData()||{}).edit) {saveValue(()=>{saveDoc(d,close)});return}
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      tabClose(false)
    } else {
      let data = {}
      if (wndData.edit) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        data.header = { author: wndData.author, date: wndData.date, from_d: wndData.from_d || 'NULL', to_d: wndData.to_d || 'NULL', article: wndData.article, posted: wndData.posted, note: (wndData.note || '').substring(0, 85) }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.article) data.header.article = { id: 'NULL' }
        else if (!wndData.article.id) data.header.article = { id: 'NULL' }
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }
      let table = wndData.list.filter(el => el.edited)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = {
            uid: el.uid,
            employee: { id: el.employee.id }, days: el.days, hours: el.hours, sum_m: el.sum_m, sum_d: el.sum_d, sum_h: el.sum_h,
            amount_a: el.amount_a, sum_a: el.sum_a, amount_t: el.amount_t, sum_t: el.sum_t, amount_d1: el.amount_d1, sum_d1: el.sum_d1,
            amount_d2: el.amount_d2, sum_d2: el.sum_d2, bonus: el.bonus, sick: el.sick, vacation: el.vacation, totall: el.totall,
            tax_base: el.tax_base, inc_tax: el.inc_tax, mil_tax: el.mil_tax, esv: el.esv, expenses: el.expenses, amount: el.amount
          }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }

      if (posted){
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
                { caption: localestr('Відмінити'), action: () => { } },
                { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modSalary&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }

      //зберегти дані по замовчуванню
      setSettings({ DocSalaryEdit: { article: wndData.article } })
      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modSalary&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modSalary&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modSalary&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postSalary&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postSalary&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  /*const printCheck=(prn=2,scr=false)=>{
      const tblData=wndData.list.filter(el=>parseInt(el.refuse.value)===0).map(el=>({id:el.id,menu:el.menu.menu_name||el.menu.name,price:parseFloat(el.sum_prc||0).toFixed(2),qtt:parseFloat(el.sum_qtt||0),amount:(parseFloat(el.sum_amount||0)+parseFloat(el.sum_discount||0)).toFixed(2),discount:parseFloat(el.sum_discount||0).toFixed(2)}))
      let sum=0
      let sumd=0
      tblData.forEach(el=>{
        sum+=parseFloat(el.amount||0)
        sumd+=parseFloat(el.discount||0)
      })
      const prnData={type:prn,screen:scr,data:{author:wndData.author,date:wndData.date,date_loc:(new Date(wndData.date)).toLocaleString().replace(',',''),id:wndData.id,hall:(wndData.tabl||{owner:{name:''}}).owner.name,table:(wndData.tabl||{name:''}).name,docType:wndData.docType,payType:wndData.payType,phone:wndData.phone,address:wndData.address,docTable:tblData,sumt:sum.toFixed(2),sumd:sumd.toFixed(2),sum:(sum-sumd).toFixed(2)}}
      if(wndData.docType&&parseInt(wndData.docType)===1){
          prnData.data.hall=localestr('Доставка')
          prnData.data.table='~'+(wndData.phone||'').substring(5)
      }
      if(wndData.discount) {
          prnData.data.discount=getIrgValue(wndData.date,wndData.discount.discount_history)
          prnData.data.client=wndData.discount.name
      }
      loaddata('action=addJobs&data='+encodeURIComponent(JSON.stringify(prnData)),undefined,()=>{})
  }

  const prn_req=(act)=>{
      msg(localestr('Куди вивести результат?'),localestr('Запитання'),[{caption:localestr('Екран'),action:()=>act(true)},{caption:localestr('Принтер'),action:()=>act()},{caption:localestr('Відмінити'),action:()=>{}}])
  }*/

  const findItem = (val) => {
    const newData = { ...wndData, findText: val }
    findDlg = false
    newData.findArr = null
    if (val.length > 1) {
      const Arr = catEmployees.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.code && el.code.indexOf(val) === 0)) && !parseInt(el.marked))
      if (Arr.length > 10) Arr.splice(10)
      newData.findArr = Arr
      if (Arr.length) findDlg = true
      else { newData.findArr = null; findDlg = false }
    }
    setWndData(newData)
  }

  const findClick = (el) => {
    const newData = { ...wndData, findText: '', findArr: null }
    findDlg = false
    setWndData(newData)
    selectionProc({ ...el })
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete') removeItem()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') filter()
  }

  const objEntries = () => {
    if (wndData.id) {
      const item = { ...wndData, type: 'docSalary' }
      tabNew('repObjEntries', localestr('Проводки') + ' ' + itemToText(item), { object: item }, true)
    }
  }

  const doc_print = (d) => {
    
    if (!d && typeof wndData === 'object') load('action=docSalary&data=' + d['id'], doc_print)
    else if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      let item = { ...d, type: 'docSalary' }
      item.table = d.table.map(el => { return { ...el } })
      tabNew('docPrint', localestr('Розрахунково-платіжна відомість'), item)
    }
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  useEffect(() => {
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  useEffect(() => {
    if (catEmployees === undefined) setTimeout(() => { context.getData('catEmployees') }, 10 + Math.floor(Math.random() * 200))
    // eslint-disable-next-line
  }, [context.data['catEmployees']])

  function setActive(el) {
    if (edit) return
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.id === 'doc_cont') return
    if (el.contains(document.activeElement)) return
    el.focus()
  }

  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ? <div className='no-print'><FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /></div> : ''  //+
  const showEdit = edit ? <div className='no-print'><SalaryForm curData={wndData.currentCol} setValue={setVal} save={saveValue} close={cancelEdit} catEmployees={catEmployees} salaryData={wndData.salaryData} /></div> : ''

  let ttlSum1 = 0
  let ttlSum2 = 0
  let ttlSum3 = 0
  wndDataList.forEach(el => {
    if (!el.employee) return
    if (!el.hide) {
      ttlSum1 += parseFloat(el.totall) || 0
      ttlSum2 += parseFloat(el.taxes) || 0
      ttlSum3 += parseFloat(el.amount) || 0
    }

  })
  if (ttlSum1 !== 0) ttlSum1 = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', textAlign: 'right' }}>{localestr('Разом') + ': ' + ttlSum1.toFixed(2)}</div>
  else ttlSum1 = ''
  if (ttlSum2 !== 0) ttlSum2 = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', textAlign: 'right' }}>{localestr('Податки') + ': ' + ttlSum2.toFixed(2)}</div>
  else ttlSum2 = ''
  if (ttlSum3 !== 0) ttlSum3 = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', textAlign: 'right' }}>{localestr('До виплати') + ': ' + ttlSum3.toFixed(2)}</div>
  else ttlSum3 = ''


  let findItems = null
  if (findDlg && wndData.findArr) {
    setTimeout(() => findDlg = false, 30000)
    const items = wndData.findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' }
      return (
        <div key={idx} style={stl} onClick={() => { findClick(el) }}>{el.id + ' - ' + el.name}</div>
      )
    })
    findItems = <div className='no-print' style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}>
      {items}
    </div>
  }

  const menuData = [
    { name: localestr('Налаштування таблиці'), icon: '#b953', action: setHidenCols },
    { name: localestr('Фільтр'), icon: '#b955', action: filter },
    { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
  ]

  /*if(wndData.currentCol&&wndData.currentCol.menu&&catGoods){
      const good=catGoods.find(el=>el.id===wndData.currentCol.menu.id)
      if(good&&good.modifiers) console.log(good)
  } */

  let menuData2 = []
  //menuData2.push({name:localestr('Рахунок'),action:()=>prn_req((scr)=>printCheck(2,scr))})
  //menuData2.push({name:localestr('Чек'),action:()=>prn_req((scr)=>printCheck(3,scr))})

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 10px)' }} tabIndex='0' id='doc_cont'
        ref={el => { setActive(el); return targetRef }}>
        <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <EditCtrl Capt={localestr('Нарахування зарплати') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='140' width2='3' disabled={true} />
          <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='22' width2='45' />
        </div>
        <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'column' }}>
          <EditCtrl Capt={localestr('Стаття витрат')} disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='120' width2='50' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('За період з')} disabled={posted} Value={wndData.from_d} typeVal={'date'} setVal={(d) => { setValue('from_d', d) }} width1='80' width2='20' />
            <EditCtrl Capt={localestr('по')} disabled={posted} Value={wndData.to_d} typeVal={'date'} setVal={(d) => { setValue('to_d', d) }} width1='20' width2='45' />
          </div>

        </div>
        <div style={{ margin: '2px 0', display: 'flex', gap: '5px', flexDirection: 'column' }}>
          {/*<EditCtrl Capt={localestr('Стаття витрат')} Value={wndData.article} typeVal={'catArticles'} setVal={(d)=>{setValue('article',d)}} width1='100' width2='120' />
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>*/}
          <EditCtrl Capt={localestr('Коментар')} disabled={posted} Value={wndData.comment} typeVal={'text'} setVal={(d) => { setValue('comment', d) }} width1='74' width2='150' />
        </div>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
            onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
          ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
            onClick={() => showHideFilter()}
            onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
          <div tabIndex='0' onClick={() => { fillDoc() }} onKeyUp={(e) => { if (e.key === 'Enter') fillDoc() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '98px', padding: '0px 2px 0 2px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px', textAlign: 'center' }}>
            {localestr('Заповнити')}
          </div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }}
              onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItems}
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
            <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
          </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol ? { ...wndData.currentCol } : undefined} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
        <div style={{ display: 'flex' }}>
          <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuData2} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div>{ttlSum1}{ttlSum2}{ttlSum3}</div>
        </div>
        {showFilter}{showEdit}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 6px)' }} tabIndex='0' id='doc_cont'
      ref={el => { setActive(el); return targetRef }}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Нарахування зарплати') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='192' width2='52' disabled={true} />
        <div style={{ minWidth: '16px', display: 'inline-block', flexGrow: 4, maxWidth: '32px' }}></div>
        <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='22' width2='190' />
        <div style={{ minWidth: '106px', display: 'inline-block', flexGrow: 106, maxWidth: '212px' }}></div>
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Стаття витрат')} disabled={posted} Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='100' width2='152' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('За період з')} disabled={posted} Value={wndData.from_d} typeVal={'date'} setVal={(d) => { setValue('from_d', d) }} width1='82' width2='104' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('по')} disabled={posted} Value={wndData.to_d} typeVal={'date'} setVal={(d) => { setValue('to_d', d) }} width1='20' width2='104' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        {/*<EditCtrl Capt={localestr('Стаття витрат')} Value={wndData.article} typeVal={'catArticles'} setVal={(d)=>{setValue('article',d)}} width1='100' width2='120' />
            <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>*/}
        <EditCtrl Capt={localestr('Коментар')} disabled={posted} Value={wndData.comment} typeVal={'text'} setVal={(d) => { setValue('comment', d) }} width1='74' width2='276' />
      </div>
      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
          onClick={() => showHideFilter()}
          onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
        <div tabIndex='0' onClick={() => { fillDoc() }} onKeyUp={(e) => { if (e.key === 'Enter') fillDoc() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '98px', padding: '0px 2px 0 2px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px', textAlign: 'center' }}>
          {localestr('Заповнити')}
        </div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        <div style={{ position: 'relative', padding: '3px' }}>
          <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }}
            onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
            style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
          <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
          {findItems}
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
          <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
        </Menu></div>
      </div>
      <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol ? { ...wndData.currentCol } : undefined} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
      <div style={{ display: 'flex' }}>
        <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => doc_print({...wndData,date: wndData.date,id: wndData.id})}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Друк')}</div></div>
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div>{ttlSum1}{ttlSum2}{ttlSum3}</div>
      </div>
      {showFilter}{showEdit}
    </div>
  )

}

export default DocSalaryEdit